<template>
	<div class="zz_header_bar">
		<div class="zz_header_mbox">
			<div class="zz_header_mlogo cl">
				<img src="@/assets/index/head01.png" style="height: 30px;" alt="">
				<img src="@/assets/index/head02.png" alt="" style="margin-top: 10px;margin-left: 10px;height: 20px;">
			</div>
			<div class="zz_header_right" :style="{width:token?'300px':'0px'}">
				<!--消息通知-->
				<el-dropdown style="position: absolute;right: 62px;" @command="handleCommand" v-if="token">
					<div style="color: #fff;cursor: pointer;position: relative;">
					消息
					<div class="hongdian" v-if="notice.num>0"></div>
				    </div>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item class="dropdowns" command="1">
								评论
								<div class="hongdians" v-if="notice.type01>0" style="top: 10px;right: 40px;"></div>
							</el-dropdown-item>
							<el-dropdown-item class="dropdowns" command="2">
								博客
								<div class="hongdians" v-if="notice.type02>0" style="top: 10px;right: 40px;"></div>
							</el-dropdown-item>
							<el-dropdown-item class="dropdowns" command="3">
								帖子
								<div class="hongdians" v-if="notice.type03>0" style="top: 10px;right: 40px;"></div>
							</el-dropdown-item>
							<el-dropdown-item class="dropdowns" command="4">
								系统通知
								<div class="hongdians" v-if="notice.type04>0" style="top: 10px;right: 10px;"></div>
							</el-dropdown-item>
						  </el-dropdown-menu>
			</el-dropdown>
				<!--消息通知-->
				<el-button type="text" id="loginDialog" @click="login" v-if="!token">
					<span style="color: #fff;font-weight: 400;">
						登录
					</span>
				</el-button>
				<!--登录状态下显示头像-->
				<el-popover
				  v-if="token"
				  placement="bottom"
				  width="260"
				  trigger="hover">
				  <div class="qianru">
					  <!--头像昵称-->
					<div class="zz_hmr_um1 cl">
						<div class="zhanzhuai-hd-uesr cl">
							<div class="zz_hmr_um1z">
								<img :src="headimgurl" alt="">
							</div>
							<div class="zz_hmr_um1y">
								<div class="zz_hmr_um_title">
									<span>{{nickname}}</span>
								</div>
							</div>
						</div>
					</div>
					<!--内容管理-->
	<!-- 				<div class="zz_hmr_um3 cl">
						<el-button type="primary" size="small" @click="rou('/neirong')">
							管理中心
						</el-button>
					</div> -->
					<!--退出登录-->
					<div class="zz_hmr_um4 cl">
						<el-button type="primary" size="small" @click="rou('/neirong')">
							管理中心
						</el-button>
						<el-button type="danger" size="small"  @click="tuichu">
							退出登录
						</el-button>
					</div>
				  </div>
				  <div class="avatar" slot="reference">
					  <img :src="headimgurl" alt="">
				  </div>
				</el-popover>
				<!--登录状态下显示头像-->
			</div>
		</div>
		
        <!--微信登录-->
		<erlogin ref="logindata"></erlogin>
	</div>
</template>

<script>
	import erlogin from "./erlogin.vue"
	import { mapGetters } from 'vuex'
	import { getQueryVariable } from "@/utils/rules"
	import { getToken } from '@/utils/auth'
	import Vue from 'vue'
	import { user_xiaoxi_num } from "@/api/user"
	export default {
		components:{
			erlogin
		},
		computed: mapGetters([
			"nickname","headimgurl","token","notice"
		]),
		data(){
			return{
				userinfo:null,
			}
		},
		watch:{
		  $route(to,from){
			this.wxlogin();
			this.$store.dispatch('user/noticeinfo');//获取消息
		  }
		},
		mounted(){
		  
		   // 注册全局登录事件对象
		   let that = this;
		       this.$nextTick(()=>{
				   window.loginEvent = new Vue();
				   loginEvent.$on("loginDialogEvent",function(){
				    that.$refs.logindata.show()
				   })
			   })
		   if(getToken()){
		   	  this.$store.dispatch('user/getInfo');
			  this.$store.dispatch('user/noticeinfo');//获取消息
		   }
		},
		methods:{
			rou(url){
				this.$router.push({
					path:url
				})
			},
			handleCommand(type){
				this.$router.push({
					path:"/neirong",
					query:{
						activeName:'ten',
						type:type
					}
				})
				if(this.$route.path=="/neirong"){
					location.reload();
				}
			},
			wxlogin(){
			  let that = this;
			  let code = this.$route.query.code?this.$route.query.code:null;
			  console.log("code",code,this.$route);
			  //如果code存在并且缓存中没有token则进行登录
			  if(code && !getToken()){
				  that.$refs.logindata.hide();
				  that.$store.dispatch('user/login', {code:code})
					.then(() => {
						 that.$store.dispatch('user/getInfo').then(()=>{
							 that.$router.push({ path: this.$route.path || '/', query: that.$route.query })
						 })
					})
					.catch(() => {
					})
			  }
			  //获取个人信息
			  if(getToken()){
				  that.$store.dispatch('user/getInfo');
			  }
					  
			},
			//登录
			login(){
				this.$refs.logindata.show(2)
			},
			async tuichu(){
			  await this.$store.dispatch('user/logout')
			  this.$router.push({ path: this.$route.path || '/', query: this.$route.query })
			  window.location.reload()
			},
		},
	}
</script>

<style lang="scss" scoped>
	//消息通知
	.dropdowns{
		position: relative;
	}
	.hongdians{
		width: 5px;
		height: 5px;
		background: #fc5531;
		border-radius: 50%;
		position: absolute;

	}
	.hongdian{
		width: 8px;
		height: 8px;
		background: #fc5531;
		border-radius: 50%;
		position: absolute;
		top: 19px;
		right: -7px;
	}
	//消息通知
	.zz_hmr_um4{
		margin-top: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
	}
	.zz_hmr_um3{
		margin-top: 15px;
		padding: 10px 0;
		background: #fafafa;
		border: 1px solid #f0f0f0;
		overflow: hidden;
		ul{
			width: 200px;
			margin: 0 auto;
			font-size: 12px;
			overflow: hidden;
			li{
				width: 170px;
				height: 25px;
				overflow: hidden;
				cursor: pointer;
				float: left;
				text-align: center;
				line-height: 25px;
				color: #333;
			}
		}
	}
	.qianru{
		width: 100%;
		.zz_hmr_um1{
			width: 230px;
			min-height: 54px;
			line-height: 25px;
			//padding: 15px;
			text-align: center;
			overflow: hidden;
			zoom: 1;
			.zz_hmr_um1y{
				height: 43px;
				padding-top: 6px;
				text-align: left;
				overflow: hidden;
				.zz_hmr_um_title{
					height: 20px;
					line-height: 20px;
					display: block;
					overflow: hidden;
					zoom: 1;
					span{
						font-size: 14px;
						    color: #333;
						    font-weight: 700;
						    display: inline;
					}
				}
			}
			.zz_hmr_um1z{
				float: left;
				width: 54px;
				height: 54px;
				margin-right: 12px;
				overflow: hidden;
				background: #ececec;
				img{
					width: 48px;
					height: 48px;
					padding: 2px;
					background: #FFF;
					border: 1px solid;
					border-color: #F2F2F2 #CDCDCD #CDCDCD #F2F2F2;
					border-radius: 5px;
				}
			}
		}
	}
	.avatar{
		width: 30px;
		height: 30px;
		border-radius: 50%;
		background: #ececec;
		position: absolute;
		right: 0px;
		top: 50%;
		margin-top: -15px;
		cursor: pointer;
		img{
			width: 100%;
			height: 100%;
			border-radius: 50%;
			position: absolute;
			left: 0px;
			top: 0px;
		}
	}
	.zz_header_bar{
		width: 100%;
		height: 65px;
		
		.zz_header_mbox{
			position: relative;
			width: 100%;
			min-width: 1200px;
			height: 100%;
			background: #00b0f0;
			  //box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2);
			z-index: 199;
			display: flex;
			.zz_header_right{
				position: absolute;
				height: 100%;
				line-height: 65px;
				top: 0px;
				right: 80px;
				width:300px;
			}
			.zz_header_mlogo{
				position: absolute;
				left: 80px;
				height: 100%;
				top: 0;
				margin-right: 10px;
				overflow: hidden;
				display: flex;
				align-items: center;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue